'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = require('../utils/toCss');

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = require('../utils/toCssValue');

var _toCssValue2 = _interopRequireDefault(_toCssValue);

var _findClassNames = require('../utils/findClassNames');

var _findClassNames2 = _interopRequireDefault(_findClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var parse = JSON.parse,
    stringify = JSON.stringify;

var RegularRule = function () {

  /**
   * We expect `style` to be a plain object.
   * To avoid original style object mutations, we clone it and hash it
   * along the way.
   * It is also the fastetst way.
   * http://jsperf.com/lodash-deepclone-vs-jquery-extend-deep/6
   */
  function RegularRule(name, style, options) {
    _classCallCheck(this, RegularRule);

    this.type = 'regular';
    var generateClassName = options.generateClassName,
        sheet = options.sheet,
        Renderer = options.Renderer;

    var styleStr = stringify(style);
    this.style = parse(styleStr);
    this.name = name;
    this.options = options;
    this.originalStyle = style;
    this.className = '';
    if (options.className) this.className = options.className;else if (generateClassName) this.className = generateClassName(styleStr, this, options.sheet);
    this.selectorText = options.selector || '.' + this.className;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }

  /**
   * Set selector string.
   * Attenition: use this with caution. Most browser didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(RegularRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // Its a setter.
      if (value != null) {
        // Don't do anything if the value has not changed.
        if (this.style[name] !== value) {
          this.style[name] = value;
          // Only defined if option linked is true.
          if (this.renderable) this.renderer.setStyle(this.renderable, name, value);
        }
        return this;
      }
      // Its a getter, read the value from the DOM if its not cached.
      if (this.renderable && this.style[name] == null) {
        // Cache the value after we have got it from the DOM once.
        this.style[name] = this.renderer.getStyle(this.renderable, name);
      }
      return this.style[name];
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setStyle(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful as inline style.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = Object.create(null);
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.selector, this.style, options);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      var sheet = this.options.sheet;

      // After we modify a selector, ref by old selector needs to be removed.

      if (sheet) sheet.rules.unregister(this);

      this.selectorText = selector;
      this.className = (0, _findClassNames2['default'])(selector);

      if (!this.renderable) {
        // Register the rule with new selector.
        if (sheet) sheet.rules.register(this);
        return;
      }

      var changed = this.renderer.setSelector(this.renderable, selector);

      if (changed && sheet) {
        sheet.rules.register(this);
        return;
      }

      // If selector setter is not implemented, rerender the sheet.
      // We need to delete renderable from the rule, because when sheet.deploy()
      // calls rule.toString, it will get the old selector.
      delete this.renderable;
      if (sheet) {
        sheet.rules.register(this);
        sheet.deploy().link();
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      if (this.renderable) {
        return this.renderer.getSelector(this.renderable);
      }

      return this.selectorText;
    }
  }]);

  return RegularRule;
}();

exports['default'] = RegularRule;


//////////////////
// WEBPACK FOOTER
// ./~/jss/lib/plugins/RegularRule.js
// module id = 321
// module chunks = 0